function iframeVideo(event) {
  const clickElement = event.currentTarget;
  const videoClass = '.component_featureCTA_video';
  const iframePopup = clickElement.querySelectorAll(videoClass);
  const closeBtn = '.component_featureCTA_close';
  const closeButtonPopUp = clickElement.querySelectorAll(closeBtn);
  const iframeId = '#iframeVideo';
  const iframeVideoId = clickElement.querySelectorAll(iframeId);
  const iframeVideoSrc = iframeVideoId[0].src;
  const videoId = getVideoId(iframeVideoSrc);
  iframeVideoId[0].src = 'https://www.youtube.com/embed/' + videoId + '?';

  if (iframePopup) {
    iframePopup[0].style.display = 'block';
    iframeVideoId[0].src += '&autoplay=1';
    iframeVideoId[0].contentWindow.focus();
  }

  const closeHandler = event => {
    iframeVideoId[0].src = iframeVideoSrc;
    iframePopup[0].style.display = 'none';
    event.stopPropagation();
  };

  closeButtonPopUp[0].addEventListener('click', closeHandler);
  closeButtonPopUp[0].addEventListener('keypress', function (e) {
    if (e.key === 'Enter' || e.keyCode == 13) {
      closeHandler();
    }
  });
}

function iframeVideo1up(event) {
  const clickElement = event.currentTarget;
  const iframeClass = '.component_inline_card_1up_video';
  const iframePopup = clickElement.querySelectorAll(iframeClass);
  const closeBtn = '.component_inline_card_1up_close';
  const closeButtonPopUp = clickElement.querySelectorAll(closeBtn);
  const iframeId = '#iframeVideo1up';
  const iframeVideoId = clickElement.querySelectorAll(iframeId);
  const iframeVideoSrc = iframeVideoId[0].src;
  const videoId = getVideoId(iframeVideoSrc);
  iframeVideoId[0].src = 'https://www.youtube.com/embed/' + videoId + '?';

  if (iframePopup) {
    iframePopup[0].style.display = 'block';
    iframeVideoId[0].src += '&autoplay=1';
    iframeVideoId[0].contentWindow.focus();
  }

  const closeHandler = event => {
    iframeVideoId[0].src = iframeVideoSrc;
    iframePopup[0].style.display = 'none';
    event.stopPropagation();
  };

  closeButtonPopUp[0].addEventListener('click', closeHandler);
  closeButtonPopUp[0].addEventListener('keypress', function (e) {
    if (e.key === 'Enter' || e.keyCode == 13) {
      closeHandler();
    }
  });
}

function getVideoId(url) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url?.match(regExp);

  return match && match[2].length === 11 ? match[2] : null;
}

export { iframeVideo, iframeVideo1up };
